// @flow
import React, { Component } from 'react';
import i18n from 'i18n-js';
import { Dimmer, Loader } from 'semantic-grab-ui/src';
import './ProgressiveContainer.scss';

type Props = {
  isLoading: boolean,
  message: string,
  children: React$Element<*>,
};

export default class ProgressiveContainer extends Component {
  static defaultProps = {
    isLoading: false,
  };

  props: Props;

  render() {
    const { message = i18n.t('loader.loading'), isLoading } = this.props;
    return (
      <div className="progressive-container">
        <Dimmer inverted active={isLoading}>
          <Loader>{message}</Loader>
        </Dimmer>
        <div>
          {!isLoading && this.props.children}
        </div>
      </div>
    );
  }
}
